module.exports = __webpack_public_path__ + "static/img/user1.caa1e44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user1.jpg
// module id = 2g0f
// module chunks = 23